import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { renderInteractiveElement } from '../../atoms/generic-elements/interactive-element/index.js';
import img$1 from '../../../../assets/images/cross-icon.svg.js';
import img from '../../../../assets/images/search.svg.js';
import { ButtonStyleTypes, ButtonSizes, ButtonTypes } from '../../atoms/buttons/enums.js';
import { disableBodyScroll, focusAndOpenKeyboard, enableBodyScroll } from '../../utilities/behavior-helpers/index.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import css_248z from './search-bar.scss.js';
import css_248z$1 from '../../atoms/buttons/generic-button/styles/primary-button.scss.js';
import css_248z$2 from '../../atoms/buttons/generic-button/styles/secondary-button.scss.js';
import css_248z$3 from '../../atoms/buttons/generic-button/styles/platform-hints.scss.js';

const TRANSITION_DURATION = 50;
const LSRecentSearchesFieldName = 'cvt-recent-searches';
const getRecentSearches = (LSFieldName) => localStorage.getItem(LSFieldName)
    ? JSON.parse(localStorage.getItem(LSFieldName))
    : [];
class SearchBar extends s {
    constructor() {
        super();
        this.rtl = false;
        this.useSimpleNavigation = false;
        this.modalOpen = false;
        this.modalClosing = false;
        this._query = '(max-width: 1023px)';
        this._isMobile = false;
    }
    _handleMediaQuery(event) {
        this._isMobile = event.detail.value;
        this.requestUpdate();
    }
    setModalPosition() {
        const modalElement = this.renderRoot.querySelector('.search-modal');
        const nav = document.querySelector('main-nav');
        if (!modalElement || !nav)
            return;
        modalElement.style.top = `${nav.getBoundingClientRect().top + nav.getBoundingClientRect().height}px`;
    }
    handleModalOpen() {
        disableBodyScroll();
        this.modalOpen = true;
        this.setModalPosition();
        const searchInput = this.shadowRoot.querySelector('search-form').shadowRoot.querySelector('.search-input');
        focusAndOpenKeyboard(searchInput, TRANSITION_DURATION);
    }
    handleModalClose(setFocus = false) {
        this.modalClosing = true;
        enableBodyScroll();
        setTimeout(() => {
            this.modalClosing = false;
            this.modalOpen = false;
            if (setFocus) {
                this.setFocus();
            }
        }, TRANSITION_DURATION);
    }
    handleCloseBtnPress(e) {
        if (e.key === 'Escape' || e.key === 'Enter') {
            this.handleModalClose(true);
        }
        const shift = e.shiftKey;
        const { activeElement } = document;
        if (e.key === 'Tab' && shift && activeElement === this) {
            e.preventDefault();
        }
    }
    setFocus() {
        var _a;
        const searchBtn = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.search-bar button');
        searchBtn === null || searchBtn === void 0 ? void 0 : searchBtn.focus();
    }
    renderRecentSearches() {
        const recentSearches = getRecentSearches(LSRecentSearchesFieldName);
        if (recentSearches.length) {
            setTimeout(() => {
                this.shadowRoot.querySelector('.recent-searches').classList.remove('empty');
            }, 0);
        }
        /* eslint-disable lit/no-invalid-html */
        return recentSearches.map((item) => x `<li class="recent-searches-item"><a href="${this.searchPageUrl}?q=${item}">${item}</a></li>`);
        /* eslint-enable lit/no-invalid-html */
    }
    focusCloseButton() {
        var _a, _b, _c;
        (_c = (_b = (_a = this.renderRoot
            .querySelector('.close-button')) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('button')) === null || _c === void 0 ? void 0 : _c.focus();
    }
    render() {
        const modalClassMap = {
            'search-modal': true,
            open: this.modalOpen,
            rtl: this.rtl || isRTL(),
            closing: this.modalClosing,
        };
        if (this.useSimpleNavigation)
            return null;
        const searchButtonOpts = {
            mainClass: 'secondary-button search-menu-button',
            isAnchor: false,
            text: this.searchButtonText,
            ariaLabel: this.searchButtonText,
            style: ButtonStyleTypes.DARK,
            size: this._isMobile ? ButtonSizes.FULLWIDTH : ButtonSizes.REGULAR,
            type: ButtonTypes.BUTTON,
            mobileInverted: false,
            mobileWhite: false,
            disabled: false,
            icon: { src: img, alt: '' },
            iconLeft: true,
            rtl: false,
        };
        const closeButtonOpts = {
            mainClass: 'secondary-button search-menu-button',
            isAnchor: false,
            text: this.closeButtonText,
            ariaLabel: this.closeButtonText,
            style: ButtonStyleTypes.DARK,
            size: this._isMobile ? ButtonSizes.FULLWIDTH : ButtonSizes.REGULAR,
            type: ButtonTypes.BUTTON,
            mobileInverted: false,
            mobileWhite: false,
            disabled: false,
            icon: { src: img$1, alt: '' },
            iconLeft: true,
            rtl: false,
        };
        return x `<lit-media-query .query="${this._query}" @changed="${this._handleMediaQuery}"></lit-media-query><div class="search-bar ${this.rtl || isRTL() ? 'rtl' : ''}"><generic-button class="show-button ${!this.modalOpen ? 'show' : ''}" type="secondary-button" styleType="${ButtonStyleTypes.DARK}" @click="${this.handleModalOpen}" size="fullWidth">${renderInteractiveElement(searchButtonOpts)}</generic-button><generic-button class="close-button ${this.modalOpen ? 'show' : ''}" type="secondary-button" styleType="${ButtonStyleTypes.DARK}" @click="${this.handleModalClose}" @keydown="${(e) => this.handleCloseBtnPress(e)}" size="fullWidth">${renderInteractiveElement(closeButtonOpts)}</generic-button><div class="${o(modalClassMap)}" @click="${this.handleModalClose}" @keydown="${(e) => e.key === 'Escape' && this.handleModalClose(true)}"><div class="inner" @click="${(e) => e.stopPropagation()}" @keydown="${(e) => e.stopPropagation()}"><search-form showClearButton ${this.rtl || isRTL() ? 'rtl' : ''} searchPageUrl="${this.searchPageUrl}" searchTitle="${this.searchTitle}" searchPlaceholder="${this.searchPlaceholder}" searchButtonText="${this.searchButtonText}" @keydown="${(e) => e.key === 'Escape' && this.handleModalClose(true)}"></search-form><ul class="recent-searches empty"><p class="recent-searches-title">${this.recentSearchesTitle}</p>${this.renderRecentSearches()}</ul><slot name="links-title"></slot><slot name="links"></slot><input type="text" aria-hidden="true" aria-disabled="true" style="opacity:0" @focus="${() => this.focusCloseButton()}" tabindex="-1"></div></div></div>`;
    }
}
SearchBar.styles = [
    css_248z,
    css_248z$1,
    css_248z$2,
    css_248z$3,
];
__decorate([
    n({ type: Boolean })
], SearchBar.prototype, "rtl", void 0);
__decorate([
    n({ type: String })
], SearchBar.prototype, "searchButtonText", void 0);
__decorate([
    n({ type: String })
], SearchBar.prototype, "closeButtonText", void 0);
__decorate([
    n({ type: String })
], SearchBar.prototype, "searchTitle", void 0);
__decorate([
    n({ type: String })
], SearchBar.prototype, "searchPlaceholder", void 0);
__decorate([
    n({ type: String })
], SearchBar.prototype, "recentSearchesTitle", void 0);
__decorate([
    n({ type: String })
], SearchBar.prototype, "searchPageUrl", void 0);
__decorate([
    n({ type: Boolean })
], SearchBar.prototype, "useSimpleNavigation", void 0);
__decorate([
    t()
], SearchBar.prototype, "modalOpen", void 0);
__decorate([
    t()
], SearchBar.prototype, "modalClosing", void 0);
customElements.define('search-bar', SearchBar);

export { LSRecentSearchesFieldName, SearchBar, getRecentSearches };
